
<div
    ref="hoverIndicator"
    class="HoverIndicator"
    :class="[`hover-indicator-${variant}`, { 'is-visible': isVisible }, customClass]"
    :style="indicatorStyle"
></div>
